import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../utils/cn';
type CTAButtonProps = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'bordo' | 'plata';
};
export const CHECKOUT_URL = 'https://amigurumi-business-pack.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'bordo'
}: CTAButtonProps) {
  const pad = size === 'lg' ? 'px-9 py-[15px] text-[18px]' : 'px-7 py-[14px] text-base';
  const skin = variant === 'plata' ? 'bg-plata-soft text-ink shadow-[0_10px_40px_-8px_rgba(236,236,237,0.45)] ring-1 ring-white/50 hover:bg-white hover:shadow-[0_16px_50px_-8px_rgba(236,236,237,0.6)] focus-visible:ring-bordo-light' : 'bg-bordo text-plata-soft shadow-[0_10px_40px_-8px_rgba(168,56,74,0.65)] ring-1 ring-plata/40 hover:bg-bordo-soft hover:shadow-[0_16px_50px_-8px_rgba(207,77,97,0.8)] focus-visible:ring-plata-soft';
  return <a href={href} className={cn('group inline-flex items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase tracking-wide leading-tight transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} style={{
    paddingLeft: "59px",
    paddingRight: "59px"
  }} data-id="element-49" data-mp="199ogmlb73hve">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" data-id="element-50" data-mp="1n6l5wibo0ra6" />
    </a>;
}